<div id="user-reached-the-day-apply-limit">
  <div class="db-error-section">
    <div class="db-error-section">
        <!-- <p *ngIf="isLanguageJapanese">{{'THANK_YOU'|translate}}</p> -->
        <p>{{'ERROR.REGISTER_REACHED_MAXIMUM_NUMBER_TODAY'|translate}}</p>
        <p *ngIf="isLanguageJapanese">{{'ERROR.PLEASE_COME_BACK_TOMORROW'|translate}}</p>
    </div>
  </div>
</div>
